// AUTO-GENERATED by generate-zod-schemas.ts — DO NOT EDIT
// Copyright 2026 Epic Digital Interactive Media LLC
// SPDX-License-Identifier: Apache-2.0

import { z } from 'zod'

export const connectorConfigSchema = z.object({
  id: z.string().max(100),
  orgId: z.string().max(100),
  workspaceId: z.string().max(100).optional(),
  userId: z.string().max(100).optional(),
  createdAt: z.string().max(200).datetime(),
  updatedAt: z.string().max(200).datetime(),
  metadata: z.record(z.string(), z.unknown()).optional(),
  extended: z.record(z.string(), z.unknown()).optional(),
  providerId: z.string().max(100),
  name: z.string().max(500),
  enabled: z.boolean(),
  direction: z.string().max(200),
  pollingIntervalMs: z.number().int().min(60000).max(86400000),
  providerConfig: z.record(z.string(), z.unknown()).optional(),
  fieldMappings: z.array(z.record(z.string(), z.unknown())).optional(),
  archived: z.boolean(),
  nextSyncAt: z.string().max(200).optional(),
  lastSyncAt: z.string().max(200).optional(),
  lastError: z.string().max(200).optional(),
  failureCount: z.number().int(),
})

export type ConnectorConfigInput = z.infer<typeof connectorConfigSchema>
